<template>
  <div>
    <div class="container">
      <LinkButton
        v-bind:key=-1
        v-bind="{routeName: 'AdminMember', routeParams: {member_id: -1}}"
      >Add new member
      </LinkButton>
    </div>
    <div  class="typed-on-paper">
      <div style="font-family: 'Garamond'; word-spacing: 8px; letter-spacing: 2px; font-size: xx-large; text-align: center">GROUP ROSTER</div>
      <br>
      <div
        class="container narrow"
        style="font-family: 'Garamond'; font-size: large; text-align: center"
      >
        <label>Search:</label>
        <input v-model="searchString">
      </div>
      <br>

      <span
        style="font-family: 'Garamond'; font-size: large; text-align: center"
        class="div-button"
        v-on:click="switchShowActive()"
        v-bind:class="{active: showActive}"
      >{{ showActiveButtonText }}</span>
      <span
        style="font-family: 'Garamond'; font-size: large; text-align: center"
        class="div-button"
        v-on:click="switchShowRecruit()"
        v-bind:class="{recruit: showRecruit}"
      >{{ showRecruitButtonText }}</span>
      <span
        style="font-family: 'Garamond'; font-size: large; text-align: center"
        class="div-button"
        v-on:click="switchShowOnLeave()"
        v-bind:class="{onleave: showOnLeave}"
      >{{ showOnLeaveButtonText }}</span>
      <span
        style="font-family: 'Garamond'; font-size: large; text-align: center"
        class="div-button"
        v-on:click="switchShowDismissed()"
        v-bind:class="{dismissed: showDismissed}"
      >{{ showDismissedButtonText }}</span>
      <br><br>
      <table>
        <th
          style="font-family: 'Garamond'; letter-spacing: 1px; font-size: large; text-align: center; font-weight: bold"
          v-for="unit in base_units"
          v-bind:key="unit.id"
          v-if="unit.id != 60 && unit.id != 59 && unit.id != 58 && unit.id != 57"
        >
          <DivLinkButton
          class="unit-buttons"
          v-bind="{routeName: 'AdminUnit', routeParams: {unit_id: unit.id}}"
        >
          {{ unit.name }}
        </DivLinkButton>
        </th>
        <tr>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 1"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 49"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 50"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 51"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 52"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 53"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 54"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 55"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 56"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 61"
            ></UnitAdminOverviewComp>
          </td>
        </tr>
      </table>
      <br>
      <table>
        <th
          v-for="unit in base_units"
          v-bind:key="unit.id"
          v-if="unit.id === 60 || unit.id === 59 || unit.id === 58 || unit.id === 57"
        >
          <DivLinkButton
            class="unit-buttons"
            v-bind="{routeName: 'AdminUnit', routeParams: {unit_id: unit.id}}"
          >
            {{ unit.name }}
          </DivLinkButton>
        </th>
        <th>
          Lost & Found
        </th>
        <tr>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 57"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 58"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 59"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <UnitAdminOverviewComp
              v-for="unit in base_units"
              v-bind:key="unit.id"
              v-bind:id="unit.id"
              v-bind:name="unit.name"
              v-bind:showActive="showActive"
              v-bind:showOnLeave="showOnLeave"
              v-bind:showDismissed="showDismissed"
              v-bind:showRecruit="showRecruit"
              v-bind:searchString="searchString"
              v-if="unit.id === 60"
            ></UnitAdminOverviewComp>
          </td>
          <td>
            <DivLinkButton
              class="member-buttons"
              v-for="member in memberPhantoms(searchString)"
              v-bind:key="member.id"
              v-bind="{routeName: 'AdminMember', routeParams: {member_id: member.member_id}}"
            >
              {{ member.callsign }}
            </DivLinkButton>
          </td>
        </tr>
      </table>

    </div>
    <br>
    <UnitAdminOverviewTotals></UnitAdminOverviewTotals>
  </div>
</template>

<script>
import UnitAdminOverviewTotals from "./UnitAdminOverviewTotals";
import UnitAdminOverviewComp from "./UnitAdminOverviewComp";
import DivLinkButton from "../basic_comp/DivLinkButton"
import HideableDiv from "../basic_comp/HideableDiv"
import {mapGetters, mapState} from "vuex";
import LinkButton from "../basic_comp/LinkButton";

export default {
  name: "UnitAdminOverview",
  components:
    {
      LinkButton,
      DivLinkButton,
      UnitAdminOverviewTotals,
      UnitAdminOverviewComp
    },
      DivLinkButton,
      HideableDiv,

  mounted () {

    if (this.$store.state.memberAdmin.base_units.length == 0){
      this.$store.dispatch('memberAdmin/loadBaseUnits', {caller: this.$options.name});
    }

    if (this.$store.state.memberAdmin.members.length == 1){
      this.$store.dispatch('memberAdmin/loadMembers', {caller: this.$options.name});
    }

  },

  data() {
    return {

      showActive: true,
      showOnLeave: true,
      showDismissed: false,
      showRecruit: true,
      searchString: "",
    }
  },
  computed: {



    showActiveButtonText: function () {

      return this.showActive ? "Hide active" : "Show active"
    },

    showOnLeaveButtonText: function () {

      return this.showOnLeave ? "Hide on leave" : "Show on leave"
    },

    showDismissedButtonText: function () {

      return this.showDismissed ? "Hide dismissed" : "Show dismissed"
    },

    showRecruitButtonText: function () {

      return this.showRecruit ? "Hide recruit" : "Show recruit"
    },

    ...mapState('memberAdmin', {
      base_units: state => state.base_units
    }),

    ...mapGetters("memberAdmin", [
      "memberPhantoms",
    ])
  },
  methods: {

    switchShowActive: function () {
      this.showActive = !this.showActive;
    },

    switchShowOnLeave: function () {
      this.showOnLeave = !this.showOnLeave;
    },

    switchShowDismissed: function () {
      this.showDismissed = !this.showDismissed;
    },

    switchShowRecruit: function () {
      this.showRecruit = !this.showRecruit;
    }
  }
}
</script>

<style scoped>

.narrow{
  font-size: 1em;
  margin: 2px 0px 0px 20px;
  padding-top: 5px;
  padding-bottom: 5px;
  width: calc(100% - 20px - 26px);
}

.active{
  background-color: rgba(0, 255, 0, 0.25);
}

.onleave{
  background-color: rgba(255, 255, 0, 0.25);
}

.dismissed{
  background-color: rgba(255, 0, 0, 0.25);
}

.recruit{
  background-color: rgba(0, 157, 255, 0.43);
}

table, th {
  border: 1px solid;
}

table, tr {
  border: 1px solid;
  width: 100%;
}

table, td {
  border: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/UnitAdminOverview.vue